/* eslint-disable no-shadow */
/* eslint-disable react/sort-comp */
/* eslint-disable react/no-unused-state */
/* eslint-disable max-len */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import styles from './authentication.module.scss';
import LoginForm from './components/LoginForm';
import OTPLoginForm from './components/OTPLoginForm';
import OTPForm from './components/OTPForm';
import Loading from '../../../components/loading';
import ApplicationForm from '../Create/ApplicationForm';
import { isLocal, hostName } from '../../../constants/apiEnv';
import ApplicationStatus from '../Create/ApplicationStatus';
import UserApplications from './components/UserApplications';
import SchedulingList from './components/SchedulingList';
import { getLogo, getTitle } from '../../../brand';

const url = hostName.slice(6);
class BadgingLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 'badgelogin',
      loadingStatus: false,
      errors: {
        phoneEmpty: true,
        passwordEmpty: true,
        invalidCredentials: false,
        invalidPassword: false,
        phoneInvalid: false,
        codeEmpty: true
      },
      blurredFields: {
        phone: false,
        password: false,
        isChecked: false,
        code: false
      },
      cognitoPhoneError: false,
      cognitoCodeError: false,
      resendSuccess: false,
      application: {},
      success_message: '',
      schemaSettings: {},
      applicationData: {}
    };
    const { match: { params: { installationId } } } = props;
    this.publicUrl = isLocal ? process.env.REACT_APP_BACKEND_PUBLICHOST : `https://apis.${installationId}${url}/public`;
    // this.publicUrl = `https://apis.us.dev.aerosimple.com/public`;

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleInputBlurred = this.handleInputBlurred.bind(this);
    this.handleAuthError = this.handleAuthError.bind(this);
  }

  async componentDidMount() {
    const { match: { params: { id, airportCode } } } = this.props;
    try {
      this.setState({ loadingStatus: true });
      const currentUrl = window.location.href;
      let apiUrl = '';
      if (currentUrl.includes('/auth/badging/login/')) {
        apiUrl = `${this.publicUrl}/badging/get_schema/${id}/${airportCode}`;
      } else if (currentUrl.includes('/badge/scheduling/')) {
        apiUrl = `${this.publicUrl}/scheduling/booking/${airportCode}/badging`;
      } else {
        apiUrl = `${this.publicUrl}/badging/get_schema/${id}/${airportCode}`;
      }
      await fetch(apiUrl)
        .then(response => response.json())
        .then((data) => {
          let requiredMap = {};
          let fieldErrors = {};
          let conditionalFields = {};
          const attachmentFields = [];
          const fields = data?.schema?.schema?.fields.filter(field => (
            field?.internal !== true
          ));
          const app = data?.data;
          fields.forEach((detailField) => {
            if (detailField.type !== 'dataSource' && detailField.type !== 'dataSourceMultiselect' && detailField.type !== 'header' && detailField.type !== 'attachments') {
              requiredMap = {
                ...requiredMap,
                [detailField.id]: detailField.required
              };
              if (!detailField.conditional) {
                fieldErrors = {
                  ...this.state.fieldErrors,
                  ...fieldErrors,
                  [detailField.id]: detailField.required
                };
              } else {
                conditionalFields[detailField?.conditional_field?.key] = detailField;
              }
            }
            if (detailField.type === 'attachments') attachmentFields.push(detailField.id);
          });
          this.setState({
            publicFiledValidations: data.public_attributes||{},
            form: data,
            fields,
            requiredMap,
            fieldErrors,
            loadingStatus: false,
            attachmentFields,
            conditionalFields,
            app,
            schemaSettings: data
          });
        });
    } catch (error) {
      let message = 'There was a problem while retrieving the form';
      this.setState({
        message,
        apiStatus: true,
        loadingStatus: false
      });
    }
    if (localStorage.checkbox && localStorage.phone !== '') {
      this.setState({
        isChecked: true,
        phone: localStorage.username,
        password: localStorage.password
      });
    }
    if (localStorage.currentPage) {
      this.setState({ currentPage: localStorage.currentPage });
    }
  }


  validateFormFields(inputType, value) {
    let errors = {};
    switch (inputType) {
      case 'phone':
        if (value === '' || value === '+') {
          errors = Object.assign(errors, { phoneEmpty: true, emailInvalid: false });
        }
        if (value !== '+') {
          errors = Object.assign(errors, { phoneEmpty: false, emailInvalid: false });
        }
        break;
      case 'otp':
        if (value !== '') {
          errors = Object.assign(errors, { codeEmpty: false });
        }
        break;
      case 'password':
        errors = Object.assign(errors, { passwordEmpty: value === '' });
        break;
      default:
        break;
    }
    this.setState(prevState => ({
      errors: Object.assign({}, prevState.errors, errors)
    }));
  }


  handleInputChange(inputType, value) {
    const { cognitoPhoneError, cognitoCodeError } = this.state;
    if (value !== '' && cognitoPhoneError === true) {
      this.setState({ cognitoPhoneError: false });
    } else if (value !== '' && cognitoCodeError === true) {
      this.setState({ cognitoCodeError: false });
    }
    this.setState({
      [inputType]: value
    }, () => this.validateFormFields(inputType, value));
  }

  handleInputBlurred(inputType) {
    this.setState(prevState => ({
      blurredFields: Object.assign({}, prevState.blurredFields, {
        [inputType]: true
      })
    }));
  }

  handlePath() {
    const { match: { url, params: { id, installationId, airportCode } } } = this.props;
    if (url === `/auth/badging/login/${id}/${installationId}/${airportCode}`) {
      this.setState({ currentPage: 'applicationForm' });
    }
  }

  handleAuthError(error) {
    switch (error.code) {
      case 'NotAuthorizedException':
      case 'UserNotFoundException':
        this.setState(prevState => ({
          errors: Object.assign({}, prevState.errors, {
            invalidCredentials: true
          })
        }));
        break;
      case 'CodeMismatchException':
        this.setState(prevState => ({
          errors: Object.assign({}, prevState.errors, {
            verificationInvalid: true
          })
        }));
        break;
      case 'LimitExceededException':
        this.setState(prevState => ({
          errors: Object.assign({}, prevState.errors, {
            LimitExceed: true
          })
        }));
        break;
      case 'InvalidPasswordException':
        this.setState(prevState => ({
          errors: Object.assign({}, prevState.errors, {
            invalidPassword: true
          })
        }));
        break;
      default:
        break;
    }
  }

  checkValues = (value, errorKey) => {
    this.setState(prevState => ({
      errors: Object.assign({}, prevState.error, {
        [errorKey]: false
      }),
      blurredFields: Object.assign({}, prevState.error, {
        [value]: true
      })
    }));
  }

  handleUser = async (e) => {
    const { phone } = this.state;
    const { match: { params: { id, airportCode } } } = this.props;
    this.setState({ loadingStatus: true });
    e.preventDefault();
    let phoneNumber = phone;
    phoneNumber = phoneNumber?.[0] + phoneNumber?.slice(1).replace(/[^\d]/g, '');
    const data = {
      phonenumber: phoneNumber
    };
    try {
      const currentUrl = window.location.href;
      let apiUrl = '';
      if (currentUrl.includes('/auth/badging/login/')) {
        apiUrl = `${this.publicUrl}/badging/create_auth/${id}/${airportCode}`;
      } else if (currentUrl.includes('/badge/scheduling/')) {
        apiUrl = `${this.publicUrl}/scheduling/booking/create_booking_auth/login/${airportCode}/`;
      } else {
        apiUrl = `${this.publicUrl}/badging/create_auth/${id}/${airportCode}`;
      }
      await fetch(apiUrl, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: { 'Content-Type': 'application/json' }
      })
        .then(response => response.json())
        .then((data) => {
          this.setState({
            message: 'OTP sent successfully.',
            apiStatus: true,
            loadingStatus: false,
            data
          });
        });
      this.handleOpenOtpForm();
    } catch (error) {
      let message = 'There was a problem while sending the form';
      if (error && error.detail) message = error.detail;
      this.setState({
        message,
        apiStatus: true,
        loadingStatus: false,
        cognitoPhoneError: true
      });
    }
  }

  handleResendOTP = async () => {
    const { phone } = this.state;
    const { match: { params: { id, airportCode } } } = this.props;
    let phoneNumber = phone;
    phoneNumber = phoneNumber[0] + phoneNumber.slice(1).replace(/[^\d]/g, '');
    this.setState({ resendSuccess: false, loadingStatus: true });
    const data = {
      phonenumber: phoneNumber
    };
    try {
      const currentUrl = window.location.href;
      let apiUrl = '';
      if (currentUrl.includes('/auth/badging/login/')) {
        apiUrl = `${this.publicUrl}/badging/create_auth/${id}/${airportCode}`;
      } else if (currentUrl.includes('/badge/scheduling/')) {
        apiUrl = `${this.publicUrl}/scheduling/booking/create_booking_auth/login/${airportCode}/`;
      } else {
        apiUrl = `${this.publicUrl}/badging/create_auth/${id}/${airportCode}`;
      }
      await fetch(apiUrl, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: { 'Content-Type': 'application/json' }
      })
        .then(response => response.json())
        .then((data) => {
          this.setState({
            message: 'OTP sent successfully.',
            apiStatus: true,
            loadingStatus: false,
            resendSuccess: true,
            data
          });
        });
      this.handleOpenOtpForm();
    } catch (error) {
      let message = 'There was a problem while sending the form';
      if (error && error.detail) message = error.detail;
      this.setState({
        message,
        apiStatus: true,
        loadingStatus: false,
        cognitoPhoneError: true
      });
    }
  }

  validateOtpField = () => {
    if (this.state.otp === '') {
      return true;
    }
    return false;
  }

  handleLogin = async (e) => {
    const { otp, phone } = this.state;
    const { match: { params: { id, installationId, airportCode } } } = this.props;
    e.preventDefault();
    this.setState({ loadingStatus: true });
    const isOTPEmpty = this.validateOtpField();
    if (!isOTPEmpty) {
      let phoneNumber = phone;
      phoneNumber = phoneNumber?.[0] + phoneNumber?.slice(1).replace(/[^\d]/g, '');
      const data = {
        phonenumber: phoneNumber,
        otp
      };
      try {
        const currentUrl = window.location.href;
        let apiUrl = '';
         if (currentUrl.includes('/auth/badging/login/')) {
          apiUrl = `${this.publicUrl}/badging/validate_otp/${installationId}/${airportCode}`;
         } else if (currentUrl.includes('/badge/scheduling/')) {
          apiUrl = `${this.publicUrl}/scheduling/booking/validate_booking_otp/${installationId}/${airportCode}/`;
         } else {
          apiUrl = `${this.publicUrl}/badging/validate_otp/${installationId}/${airportCode}`;
         }
        await fetch(apiUrl, {
          method: 'POST',
          body: JSON.stringify(data),
          headers: { 'Content-Type': 'application/json' }
        })
          .then(response => response.json())
          .then((data) => {
            if (data?.message==='Login successfull') {
                this.setState({
                  message: 'Login successfull',
                  apiStatus: true,
                  loadingStatus: false
              });
              const reOpenApplication = data?.badge_data?.filter(d => d.id === Number(id) && (d.status === 2 || d.status === 7));
              if (reOpenApplication.length > 0) {
                  this.setState({
                    currentPage: 'badgeExpired',
                    applicationData: reOpenApplication[0]
                  });
              } else {
                this.handlePath();
                this.handleBadge();
              }
            } else if (data?.message==='OTP verified successfully') {
                this.setState({
                  currentPage: 'badgeReschedule',
                  applicationData: data?.badge_data,
                  loadingStatus: false
                });
            } else {
              this.setState({
                loadingStatus: false,
                cognitoCodeError: true
              });
            }
          });
      } catch (error) {
        let message = 'Incorrect otp';
        if (error && error.detail) message = error.detail;
        this.setState({
          message,
          loadingStatus: false,
          cognitoCodeError: true
        });
      }
    } else {
      this.setState(prevState => ({
        errors: Object.assign({}, prevState.error, {
          codeEmpty: true
        }),
        blurredFields: Object.assign({}, prevState.error, {
          code: true
        }),
        cognitoCodeError: false,
        loadingStatus: false
      }));
    }
  }

   onChangeRememberMe =(event) => {
     this.setState({
       isChecked: event.target.checked
     });
   }

  handleOTPLogin = () => {
    this.setState({ currentPage: 'otpLogin' });
  }

  handleBadge = () => {
    this.setState({ currentPage: 'applicationForm' });
    localStorage.setItem('currentPage', this.state.currentPage);
  }

  handleStatus = (badge) => {
    this.setState({ currentPage: 'badgeStatus', application: badge.info, success_message: badge.successMessage });
    localStorage.setItem('currentPage', this.state.currentPage);
  }

  handleOpenOtpForm = () => {
    this.setState({ currentPage: 'otpForm' });
  }

  handleChangeForgotPassword = () => {
    this.setState({
      currentPage: 'ChangeForgotpassword'
    });
  }

  handleRenewBadge = async (id) => {
    const { match: { params: { installationId, airportCode } }, history } = this.props;
    const { otp, phone } = this.state;
    let phoneNumber = phone;
    phoneNumber = phoneNumber[0] + phoneNumber.slice(1).replace(/[^\d]/g, '');
    try {
      await fetch(`${this.publicUrl}/badging/renew_badge/${id}/${airportCode}`, {
        headers: {
          'Authorization': `Basic ${btoa(`${phoneNumber}:${otp}`)}`
        }
      })
        .then(response => response.json())
        .then((data1) => {
          this.setState({
            renewalApplicationData: data1
          });
          history.push(`/auth/badging/login/${data1.id}/${installationId}/${airportCode}`);
          this.handlePath();
        });
    } catch (error) {
      let message = 'There was a problem while submitting the form';
      if (error && error.detail) message = error.detail;
      this.setState({
        message,
        apiStatus: true,
        loadingStatus: false
      });
    }
  }

  handleRejectBadge = async (id) => {
    const { match: { params: { installationId, airportCode } }, history } = this.props;
    const { otp, phone } = this.state;
    let phoneNumber = phone;
    phoneNumber = phoneNumber[0] + phoneNumber.slice(1).replace(/[^\d]/g, '');
    try {
      await fetch(`${this.publicUrl}/badging/portal_reject_reopen_badge/${id}/${airportCode}`, {
        headers: {
          'Authorization': `Basic ${btoa(`${phoneNumber}:${otp}`)}`
        }
      })
        .then(response => response.json())
        .then((data1) => {
          this.setState({
            renewalApplicationData: data1
          });
          history.push(`/auth/badging/login/${data1.id}/${installationId}/${airportCode}`);
          this.handlePath();
        });
    } catch (error) {
      let message = 'There was a problem while submitting the form';
      if (error && error.detail) message = error.detail;
      this.setState({
        message,
        apiStatus: true,
        loadingStatus: false
      });
    }
  }

  handleCancelSuccess = (cancelledId) => {
    this.setState(prevState => ({
      applicationData: prevState.applicationData?.map(item => (item.id === cancelledId ? { ...item, status: 'cancel' } : item))
    }));
  };

  handleRescheduleSuccess = (updatedItem) => {
    this.setState(prev => ({
      applicationData: prev.applicationData?.map(item => (item.id === updatedItem.id ? updatedItem : item))
    }));
  };

  render() {
    const {
      currentPage,
      errors,
      blurredFields,
      isChecked,
      password,
      phone, otp,
      cognitoPhoneError,
      cognitoCodeError,
      loadingStatus,
      resendSuccess,
      application,
      form,
      success_message,
      schemaSettings,
      applicationData,
      renewalApplicationData
    } = this.state;
    const { match: { url, params: { id, installationId, airportCode } } } = this.props;
    let formToRender;
    if (currentPage === 'badgelogin') {
      formToRender = (
        <LoginForm
          handleInputChange={this.handleInputChange}
          handleSignIn={this.handleUser}
          errors={errors}
          url={url}
          blurredFields={blurredFields}
          handleInputBlurred={this.handleInputBlurred}
          onChangeRememberMe={this.onChangeRememberMe}
          isRemember={isChecked}
          phone={phone}
          password={password}
          handleForgotPassword={this.handleForgotPassword}
          handleOTPLogin={this.handleOTPLogin}
          cognitoPhoneError={cognitoPhoneError}
          application={application}
        />
      );
    } else if (currentPage === 'otpLogin') {
      formToRender = (
        <OTPLoginForm
          handleInputChange={this.handleInputChange}
          errors={errors}
          blurredFields={blurredFields}
          handleInputBlurred={this.handleInputBlurred}
          phone={phone}
          handleUser={this.handleUser}
        />
      );
    } else if (currentPage === 'otpForm') {
      formToRender = (
        <OTPForm
          handleInputChange={this.handleInputChange}
          errors={errors}
          blurredFields={blurredFields}
          handleInputBlurred={this.handleInputBlurred}
          cognitoCodeError={cognitoCodeError}
          otp={otp}
          handleLogin={this.handleLogin}
          handleResendOTP={this.handleResendOTP}
          resendSuccess={resendSuccess}
        />
      );
    } else if (currentPage === 'applicationForm') {
      formToRender = (
        <ApplicationForm
          otp={otp}
          phone={phone}
          airportCode={airportCode}
          id={id}
          installationId={installationId}
          handleBadgeStatus={this.handleStatus}
          form={form}
          schemaSettings={schemaSettings}
          renewalApplicationData={renewalApplicationData}
          rejectApplicationData={applicationData}
        />
      );
    } else if (currentPage === 'badgeStatus') {
      formToRender = (
        <ApplicationStatus item={application} successMessage={success_message} />
      );
    } else if (currentPage === 'badgeExpired') {
      formToRender = (
        <UserApplications
          data={applicationData}
          renewBadge={this.handleRenewBadge}
          rejectBadge={this.handleRejectBadge}
        />
      );
    } else if (currentPage === 'badgeReschedule') {
      formToRender = (
        <SchedulingList
          data={applicationData}
          onCancelSuccess={this.handleCancelSuccess}
          onRescheduleSuccess={this.handleRescheduleSuccess}
        />
      );
    }
    return (
      <div className={styles.authentication}>
        <div className={styles.logo_container} style={{ flexDirection: 'row', padding: currentPage === 'applicationForm'?'50px 0 17px 0' : '240px 0 60px 0' }}>
          {currentPage !== 'applicationForm' && (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <img src={getLogo()} alt="logo" style={{ maxWidth: '37px' }} />
            <span className={styles.brand} style={{ fontSize: '37px', letterSpacing: '1px' }}>{getTitle()}</span>
          </div>
          )}
          {currentPage === 'applicationForm' && (
          <h3 className="text-center" style={{ fontWeight: 'bold', color: '#fff' }}>{form?.airport_data?.name}</h3>
          )}
        </div>
        <div className={styles.form_container}>
          {formToRender}
        </div>
        <Loading loadingStatus={loadingStatus} />
      </div>
    );
  }
}

BadgingLogin.propTypes = {
  match: PropTypes.shape({}).isRequired
};

export default connect(null)(withRouter(BadgingLogin));
